import { TAGS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/tags_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { TagEntityType } from '../types/tags';

const targetCollectionNames = [TagEntityType.PART, 'partsIndex'];

const initialState: any = standardInitialStateGenerator(targetCollectionNames);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
